'use client'

import { type ReactNode } from 'react'
import { CAROUSEL_CARD_STYLES } from '.'

/**
 * Wrapper that ensures we show 3.5 cards per row on desktop, and 1.5 cards per row on mobile.
 */

export const CarouselCardWrapper = ({
  children,
  onClick,
}: {
  children: ReactNode
  onClick?: () => void
}) => {
  return (
    <div className={CAROUSEL_CARD_STYLES} onClick={onClick}>
      {children}
    </div>
  )
}
